export const OUTPUT_PROP_MODES = {
    jsx: 'jsx',
    js: 'js',
    raw: 'raw',
};
